import GoogleMap from '../classes/GoogleMap';
	
const apiKey = WP.gmaps_api_key;
const env = WP.env;
let mapInstances = null;
let apiRequested = false;

// create the gmaps callback, that resolves a promise
const apiPromise = new Promise((resolve, reject) => {
	window.baseThemeCreateGoogleMaps = () => resolve();
});

export const loadAPI = () => {

	// // prevent multiple instantiations
	if (!apiRequested) {
		apiRequested = true;	

		// append the Google Maps script to the head
		const jsFile = document.createElement('script');
		jsFile.src = 'https://maps.googleapis.com/maps/api/js?callback=baseThemeCreateGoogleMaps&loading=async&libraries=marker';
		if (env === 'production') {
			jsFile.src += '&key=' + apiKey;
		}
		document.getElementsByTagName('head')[0].appendChild(jsFile);
	}

	// return the promise
	return apiPromise;
};

export const createMaps = () => {
	mapInstances.forEach(el => new GoogleMap(el, JSON.parse(el.getAttribute('data-map-locations'))));
};

export default () => {

	mapInstances = document.querySelectorAll('.js-google-map');

	// if no maps on the page, bail
	if (mapInstances.length === 0) return;
	
	// load the api, then create the maps when ready
	loadAPI().then(createMaps.bind(this));

};
